import
{
	AfterViewChecked,
	AfterViewInit, ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	Inject,
	isDevMode,
	NgZone, OnInit,
	ViewChild
} from '@angular/core';
import { BehaviorSubject, filter, forkJoin, interval, Observable, of, Subject, Subscription, takeUntil } from 'rxjs';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService, } from '@azure/msal-angular';
import { InteractionStatus, RedirectRequest, } from '@azure/msal-browser';
import { Clipboard } from '@angular/cdk/clipboard';
import { AuthService } from './services/auth.service';
//ZZZ import { NavService } from './services/nav.service';
import { NavService } from 'libComm';
//ZZZ import { NavItem } from './models/NavItem';
import { NavItem } from 'libComm';
import { MediaMatcher } from '@angular/cdk/layout';
import { NavigationService } from "./services/utils/navigation.service";
import { TranslateService } from "@ngx-translate/core";
import { GeneralService } from "./services/crud/general.service";
import { CheckForUpdateService } from "./services/check-for-update.service";
import { SpinnerService } from "./services/spinner.service";
import { cloneDeep } from "lodash";
import { catchError, map, tap } from "rxjs/operators";
import { AnnounceService } from "./services/announcements.service";
import { FormControl } from '@angular/forms';
import { HttpSpinnerInterceptorService } from './services/http-spinner.interceptor.service';
import { TranslationService } from "./services/translation-service";

// LZ libCommService for library initialization and integration
import {LibCommService} from "libComm";
import {EURMenuService} from "./_lib_integration/services/EURMenu.service";
import { MenuService } from './services/menu.service';

export interface ColumnSetting {
	hiddenColumns: string[];
}

export interface ColumnSettings {
	[key: string]: ColumnSetting;
}


export interface Announce
{
	id: string
	priority: string
	text: string
	message_goes_on: string
	message_goes_off: string
	block_users_starts: string
}

export interface ExtendedAnnounce
{
	id: string
	priority: string
	text: string
	message_goes_on: string
	message_goes_off: string
	block_users_starts: string
	interval: Subscription
}


@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewChecked
{
	// title = 'EUR';
	title = ''; // provided later

	private readonly _destroying$ = new Subject<void>();

	_ShowTableSubject = new BehaviorSubject<string>('');
	ShowTableSubject = this._ShowTableSubject.asObservable();

	isLoggedIn: boolean = false;
	email: string = this.msalService.instance.getActiveAccount()?.username || '';

	role: String = '';

	appDrawer!: ElementRef;

	// The @ViewChild decorator is used to get a reference to a DOM element or a child component within the template.
	// 'appDrawer' is the template reference variable to identify the element (the one defined as '#appDrawer' in .html)
	// static: false is an option that specifies when the view query should be resolved (false == dynamically)
	//	
	@ViewChild('appDrawer', { static: false }) set drawer(drawer: ElementRef)
	{
		if (drawer)
		{
			this.appDrawer = drawer;
		}
	}

	mobileQuery!: MediaQueryList;

	private _mobileQueryListener!: () => void;

	// navItems: NavItem[] = []; // LZ: menu items no more used: now part of libComm

	allerts: ExtendedAnnounce[] = [];

	foundYes: boolean = false;

	isLoading: boolean = true;

	constructor(
		private ls: LibCommService, // LZ
		@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
		private msalService: MsalService,
		private broadcastService: MsalBroadcastService,
		private authService: AuthService,
		private clipboard: Clipboard,
		// private navService: NavService,
		changeDetectorRef: ChangeDetectorRef,
		media: MediaMatcher,
		private navigation: NavigationService,
		public translate: TranslateService,
		private httpService: GeneralService,
		private swUpdate: CheckForUpdateService,
		public spinner: SpinnerService,
		private ngZone: NgZone,
		public allertService: AnnounceService,
		public translation: TranslationService,
		private menuService: MenuService,

		private eurMenuService: EURMenuService
	)
	{
		/////////////////////////////
		// libComm initialization

		// get application name
		this.title = ls.getCoreService().getAppInfo().getAppShortName();

		// initialize library and all its internals
		ls.libInit();

		this.swUpdate.checkVersion();
		this.mobileQuery = media.matchMedia('(max-width: 600px)');
		this._mobileQueryListener = () => changeDetectorRef.detectChanges();
		this.mobileQuery.addListener(this._mobileQueryListener);

		this.httpService.getAllertByValidity().subscribe(res =>
		{
			this.allertService.replaceAllert(res?.oContent?.map(announce =>
			{
				const self = cloneDeep({ // Store a reference to the object
					id: announce.id,
					priority: announce.priority,
					text: announce.text,
					message_goes_on: announce.message_goes_on,
					message_goes_off: announce.message_goes_off,
					block_users_starts: announce.block_users_starts,
					interval: interval(5000).pipe(tap(temp =>
					{
						if (new Date(self.block_users_starts) <= new Date() && new Date(self.message_goes_off) > new Date() && self.block_users_starts !== null && (self.block_users_starts !== 'Thu Jan 01 1970 01:00:00 GMT+0100'))
						{
							self.priority = 'custom'; // Access object's properties using sel
							self.interval.unsubscribe();//
							this.pagesInit();
							// this.navigation.home()
						} else if (new Date(announce.message_goes_off) <= new Date())
						{
							self.interval.unsubscribe();
							this.pagesInit();
							// this.navigation.home();
						} else
						{
							this.pagesInit();
							self.priority = 'custom';
						}

					})).subscribe()
				});
				return self;
			}) ?? []);

		});

	}


	ngOnInit(): void
	{
		this.isLoading = true;

		//Langauges stuff...
		const defualtLanguage = "en";

		//The follwings localStorage element are setted when the user change language
		let selectedLanguage: string = localStorage.getItem('selectedLanguage') ?? defualtLanguage; //Id of the language

		this.translate.addLangs([selectedLanguage]);
		this.translate.defaultLang = defualtLanguage;
		this.translate.currentLang = selectedLanguage;

		const getTranslationsForDefault: Observable<any> = this.translate.getTranslation(defualtLanguage);
		const setCurrentLanguageAndGetTranslation = this.translate.getTranslation(selectedLanguage);
		const getAvailableLanguages = this.translation.getAvailableLanguages();

		forkJoin({
			defaultTranslation: getTranslationsForDefault,
			currentTranslation: setCurrentLanguageAndGetTranslation,
			availableLanguages: getAvailableLanguages
		})
			.pipe(catchError((error: any, caught: any) =>
			{
				console.error("Error loading translation information: ", error);
				return of(error);
			}
			))
			.subscribe(res =>
			{
				this.translate.setTranslation(selectedLanguage, res.currentTranslation); //Current language
				this.translate.setTranslation(defualtLanguage, res.defaultTranslation); //Default language
				this.translate.addLangs(res.availableLanguages ?? ['en']); //Add the list of available langauges
				this.isLoading = false;
			});

		localStorage.setItem('changes', 'false')
		this.broadcastService.inProgress$.pipe(
			filter(
					(status: InteractionStatus) => status === InteractionStatus.None
			),
			takeUntil(this._destroying$)
		).subscribe(() =>
		{
			this.isLoggedIn = this.msalService.instance.getAllAccounts().length > 0;


			if (this.isLoggedIn)
			{
				this.msalService.instance.setActiveAccount(
					this.msalService.instance.getAllAccounts()[0]
				);

				this.authService.nameBS.next(
					this.msalService.instance.getActiveAccount()?.name || ''
				);

				this.authService.emailBS.next(
					this.msalService.instance.getActiveAccount()?.username || ''
				);

				this.authService.getUser().subscribe(res =>
				{
					if (!!(res['oContent'])['sFilterSettings'])
					{
						const filter = JSON.parse((res['oContent'])['sFilterSettings'])
						localStorage.setItem('filter', filter['filters'])


						//LZ: spread filters settings retrived from DB into session storage (the one used by all pages)
						this.populateFilterSessionStorage(filter['filters']);
					}


					//Check if the users has a preferences for hidden columns
					if (!!(res['oContent'])['sColumnSettings'])
					{
						const columnSettings:string | undefined = res['oContent']['sColumnSettings'];

						this.populateColumnSessionStorage(columnSettings);
					}

				})



				this.pagesInit();
			}
		});
	}

	// LZ: takes filters values received from DB and store them into the session storage (the one used by all pages)
	populateFilterSessionStorage(fltSt: any): void
	{
		if (fltSt)
		{
			const fltObj = JSON.parse(fltSt);

			const oContent = Object.entries(fltObj);

			for (const pages_data of oContent)
			{
				const page_name = pages_data[0];
				const page_info = pages_data[1] as { instance: any }; // explicitly cast 'page_info' to have a key named 'instance' of type 'any'

				// console.log('page=' + page_name);
				// console.log(page_info['instance']);
				sessionStorage.setItem('FLT_' + page_name, JSON.stringify(page_info['instance']));
			}
		}
	}


	/**
	 * Parses the provided column settings string and stores each page's column settings
	 * in sessionStorage using a key formatted as `${pageId}_COLUMN_SETTINGS`.
	 *
	 * @param columnSettings - A JSON string representing column settings, or undefined.
	 */
	populateColumnSessionStorage(columnSettings: string | undefined): void
	{
		if (columnSettings && columnSettings.length>0)
		{
			const columnSettingParsed : ColumnSettings = JSON.parse(columnSettings);
			sessionStorage.setItem(`COLUMN_SETTINGS` , columnSettings);
			const pageIdList: string[] = Object.keys(columnSettingParsed);

			for (const pageId of pageIdList)
			{
				sessionStorage.setItem(`${pageId}_COLUMN_SETTINGS` , JSON.stringify(columnSettingParsed[pageId]));
			}
		}
	}
	// ngAfterViewChecked()
	// {
		// if (this.appDrawer)
		// {
			// this.navService.appDrawer = this.appDrawer;
		// }
	// }

	// 'ngAfterViewInit' is a lifecycle hook, the 'appDrawer' property is accessed, and operations are performed
	ngAfterViewChecked()
	{
		if (this.appDrawer)
		{
			this.ls.getCoreService().getNavService().appDrawer = this.appDrawer;
		}
	}	

	ngOnDestroy(): void
	{
		this._destroying$.next(undefined);
		this._destroying$.complete();
	}

	getToken(): string
	{
		return String(localStorage.getItem('token'));
	}

	copyToken(): void
	{
		this.ShowTableSubject.subscribe((token) =>
		{
			this.clipboard.copy(token);
		});
	}

	login(): void
	{
		if (!!!this.msalService.instance.getActiveAccount())
		{
			if (this.msalGuardConfig.authRequest)
			{
				this.msalService.loginRedirect({
					...this.msalGuardConfig.authRequest,
				} as RedirectRequest);
			} 
			else
			{
				this.msalService.loginRedirect();
			}
		} 
		else
		{
			this._ShowTableSubject.next(
				<string>this.msalService.instance.getActiveAccount()?.idToken
			);

			localStorage.setItem(
				'token',
				<string>this.msalService.instance.getActiveAccount()?.idToken
			);
		}
	}

	logout()
	{
		this.msalService.instance.logout();
	}

	isDevMode()
	{
		return isDevMode();
	}

	private pagesInit()
	{
		// get available menus from authorization service
		this.authService.getMenu().subscribe((res) =>
		{
			if (!!res)
			{
				// this.navItems = res['oContent']['userMenus'];
				this.menuService.updateState(res['oContent']['userMenus']);
				// this.menuService.updateBadgeInfo();	// LZ badges on menus are not used at the moment			

				this.authService.roleBS.next(
					res['oContent']['userRoles'][0]['_sRoleId']
				);
			}
		});

		// get available pages from authorization service
		this.authService.getPages().subscribe(res =>
		{
			this.navigation.setNavigationItems((res['oContent'])['pages']);
		})
	}
}
